/* =========================================================
   ELASA — Premium Interactivity Layer
   Paste into: Online Store > Themes > Edit code > layout/theme.liquid
   Add just before </body>:
   <script src="{{ 'elasa-premium.js' | asset_url }}" defer></script>
   (after uploading this file under Assets)
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {

  /* 1. Header shrinks + gains a gold hairline after scrolling */
  var header = document.querySelector('.header-wrapper');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('elasa-scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* 2. One orchestrated hero entrance on first load only */
  var hero = document.querySelector('.banner, .slideshow__slide');
  if (hero) {
    requestAnimationFrame(function () {
      hero.classList.add('elasa-hero-in');
    });
  }

  /* 3. Back-to-top button */
  var topBtn = document.createElement('button');
  topBtn.className = 'elasa-top-btn';
  topBtn.setAttribute('aria-label', 'Back to top');
  topBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
  document.body.appendChild(topBtn);
  topBtn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  window.addEventListener('scroll', function () {
    topBtn.classList.toggle('is-visible', window.scrollY > 500);
  }, { passive: true });

  /* 4. Wishlist heart on every product card (stored locally per device) */
  var WISHLIST_KEY = 'elasa_wishlist';
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
    catch (e) { return []; }
  }
  function saveWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  }
  function heartSVG() {
    return '<svg viewBox="0 0 24 24" stroke-width="1.8"><path d="M12 21s-7-4.35-9.5-8.5C.5 8.5 3 5 6.5 5c2 0 3.2 1 5.5 3.3C14.3 6 15.5 5 17.5 5 21 5 23.5 8.5 21.5 12.5 19 16.65 12 21 12 21z"/></svg>';
  }

  document.querySelectorAll('.card-wrapper').forEach(function (card) {
    var media = card.querySelector('.card__media');
    var link = card.querySelector('a.card__heading, a[href*="/products/"]');
    if (!media || !link) return;

    var handle = link.getAttribute('href');
    var btn = document.createElement('button');
    btn.className = 'elasa-wishlist-btn';
    btn.setAttribute('aria-label', 'Save to wishlist');
    btn.innerHTML = heartSVG();

    if (getWishlist().indexOf(handle) > -1) btn.classList.add('is-active');

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var list = getWishlist();
      var idx = list.indexOf(handle);
      if (idx > -1) { list.splice(idx, 1); btn.classList.remove('is-active'); }
      else { list.push(handle); btn.classList.add('is-active'); }
      saveWishlist(list);
    });

    media.style.position = 'relative';
    media.appendChild(btn);
  });

  /* 5. Add-to-cart micro-interaction: button morphs to a checkmark briefly */
  document.querySelectorAll('form[action*="/cart/add"] button[type="submit"]').forEach(function (btn) {
    var originalText = btn.textContent;
    btn.addEventListener('click', function () {
      setTimeout(function () {
        btn.classList.add('elasa-added');
        btn.innerHTML = '<span class="elasa-check">✓ Added</span>';
        setTimeout(function () {
          btn.classList.remove('elasa-added');
          btn.textContent = originalText;
        }, 1600);
      }, 400); // small delay lets the theme's own add-to-cart request fire first
    });
  });

  /* 6. Image shimmer while product images load */
  document.querySelectorAll('.card__media img, .product__media img').forEach(function (img) {
    var wrap = img.closest('.card__media, .product__media');
    if (!wrap) return;
    if (!img.complete) {
      wrap.classList.add('elasa-shimmer');
      img.addEventListener('load', function () { wrap.classList.remove('elasa-shimmer'); }, { once: true });
    }
  });

});
